module.exports = __webpack_public_path__ + "img/smartHome-sm.fa3ea840.jpg";